import { Platform, TextInput, View } from 'react-native';
import { Text } from '@/components/Text';
import theme from '@/config/theme';
import { styles } from './ConfirmDeleteAccount.styles';

type ConfirmDeleteAccountProps = {
  onTextChange: (value: string) => void;
};

export const ConfirmDeleteAccount = ({
  onTextChange,
}: ConfirmDeleteAccountProps) => {
  return (
    <View style={styles.wrapper}>
      <Text style={styles.mainText}>
        Schreiben Sie
        <Text style={styles.boldText}> &quot;löschen&quot; </Text>
        in das Eingabefeld, um die Löschung Ihres Accounts zu bestätigen.
      </Text>
      <View style={styles.inputWrapper}>
        <TextInput
          allowFontScaling={false}
          style={[
            styles.textInput,
            Platform.OS === 'ios'
              ? {
                  lineHeight: 0,
                  color: theme.colors.newUI.therapist.textBlue100,
                }
              : { color: theme.colors.newUI.therapist.textBlue100 },
          ]}
          placeholder="löschen"
          placeholderTextColor="gray"
          onChangeText={onTextChange}
          autoComplete="off"
        />
      </View>
    </View>
  );
};
